module.exports = __webpack_public_path__ + "static/media/Reverb (Ambient reverb) VR.c6fbc51.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/pedal/Reverb (Ambient reverb) VR.mp3
// module id = 0kHu
// module chunks = 12